import { X_API_KEY } from '../../config/config';
import { get } from './http';
import store from 'store';
export function fetchFileDownload(doc_id, params = { verbose: 100 }) {
  const config = {
    headers: {
      'x-api-key': X_API_KEY,

    },
  };
  const data = {
    ...params,
  };
  return get(`/api/common/documents/${doc_id}`, data, config);
}

export function fetchFileTokenDownload(doc_id, params = { verbose: 100 }) {
  const storage = store.get('token_download') || {};
  const config = {
    headers: {
      Authorization: `Bearer ${storage.access_token}`,
    },
  };
  const data = {
    ...params,
  };
  return get(`/api/common/documents/${doc_id}`, data, config);
}
